export default "__VITE_ASSET__CgGEHsDc__"